import { useTranslation } from "react-i18next";
import { Spinner, Text } from "@/shared/ui";

/** The router's default `pendingComponent` — a calm loading state for every route. */
export function RoutePending() {
  const { t } = useTranslation();
  return (
    <div className="grid min-h-full place-items-center py-16">
      <div className="flex items-center gap-3">
        <Spinner label={t("common.loading")} />
        <Text variant="body" className="text-ink-faint">
          {t("common.loading")}
        </Text>
      </div>
    </div>
  );
}
